module.exports = __webpack_public_path__ + "img/C - 01.8d142c3f.png";